import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "72",
  height: "72",
  fill: "none",
  viewBox: "0 0 72 72"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FF8D07",
      d: "M36 66C19.431 66 6 52.568 6 36 6 19.431 19.431 6 36 6c16.568 0 30 13.431 30 30 0 16.568-13.432 30-30 30m0-6c13.255 0 24-10.745 24-24S49.255 12 36 12 12 22.745 12 36s10.745 24 24 24m-3-15h6v6h-6zm0-24h6v18h-6z"
    }, null, -1)
  ]))]))
}
export default { render: render }